module.exports = __webpack_public_path__ + "img/background-video-slider-nissan.185d8451.jpg";